<template>
    <v-card class="ma-2">
        <v-card-text>
            <v-row>
            <v-col cols="3" class="d-flex justify-start flex-grow-0 flex-shrink-1">
                <v-img
                :src="loadImg"
                max-height="100px"
                @error="loadDefaultImg">
                </v-img>
            </v-col>
            <v-col cols="9" class="flex-grow-1 flex-shrink-0" >
                <p>{{ product.title }}</p>
                <p>R$ {{ product.price }}</p>
            </v-col>
            </v-row>
        </v-card-text>
        <br/>
    </v-card>
</template>

<script>
import Api from '../../services/Api';
export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    methods: {    
        loadDefaultImg(){
            this.showDefaultImg = true;
        }
    },
    computed:{        
        loadImg: function(){
            return (this.product.media == undefined ? 
                "https://cdn.vuetifyjs.com/images/cards/store.jpg" : 
                Api.getBaseUrl()+"imagens/"+this.product.media.name);
        }
    }
}
</script>
